/**
 * @generated SignedSource<<18a4d5fc49a67439b3bc469c2f5e80c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeeSheetAgendaHeaderDesktopNewFragment_club$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"FacilityLogoFragment_club">;
  readonly " $fragmentType": "TeeSheetAgendaHeaderDesktopNewFragment_club";
};
export type TeeSheetAgendaHeaderDesktopNewFragment_club$key = {
  readonly " $data"?: TeeSheetAgendaHeaderDesktopNewFragment_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeeSheetAgendaHeaderDesktopNewFragment_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeeSheetAgendaHeaderDesktopNewFragment_club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FacilityLogoFragment_club"
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "771a7867cad113d2f0dfb8e35b87b1ae";

export default node;
